import { removeItem } from '../storage';
import { clearFeatureFlags } from '../featureFlags/featureFlags';

export const handleUnauthorized = () => {
  // Prevent redirect loops if already on login page
  if (globalThis.location.pathname.startsWith('/login') || globalThis.location.pathname === '/admin/login') {
    return;
  }

  // Clear all session data
  removeItem('user');
  removeItem('lqaUser');
  removeItem('originalUser');
  clearFeatureFlags();

  globalThis.location.href = '/login';
};
